@if (pagination() && ((isLoading()) || !isLoading()))
{
  <div class="flex items-center justify-center">
    <div class="flex items-center mt-4">
      <button  [ngClass]="{'hover:bg-gray-300 cursor-pointer': pagination().currentPage !== 1}" [disabled]="pagination().currentPage === 1" (click)="changePage(pagination().currentPage - 1)" class="h-12 w-12 mr-1 flex justify-center items-center rounded-full bg-gray-200 cursor-pointer hover:bg-gray-300">
        <span class="text-lg">‹</span>
      </button>
      @for (page of getDisplayedPages(); track $index)
      {
        <button class="h-12 w-12 mx-1 justify-center items-center rounded-full cursor-pointer relative" 
          [ngClass]="{
            'bg-blue-500 hover:bg-blue-300 text-white flex': page === pagination().currentPage, 
            'bg-gray-200 hover:bg-gray-300 flex': page !== pagination().currentPage,
            'hidden sm:flex flex': page !== pagination().currentPage
          }" (click)="changePage(page)" [disabled]="pagination().currentPage === page || page === '...'">
          @if (page !== '...')
          {
            @if (isLoading()  && page === pagination().currentPage)
            {
              
              <mat-spinner diameter="20" class="flex absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></mat-spinner>
           
            }
            @else
            {
              <span class="text-lg">{{ page }}</span>
            }
          }
          @else 
          {
            <span class="text-lg">...</span>            
          }
        </button>
      }            
      
      <button [ngClass]="{'hover:bg-gray-300 cursor-pointer': pagination().currentPage !== pagination().totalPages}" [disabled]="pagination().currentPage === pagination().totalPages" (click)="changePage(pagination().currentPage + 1)" class="h-12 w-12 ml-1 flex justify-center items-center rounded-full bg-gray-200 ">
        <span class="text-lg">›</span>
      </button>
    </div>
  </div>

}